<template>
  <LayoutDefault>
    <ContentTitle ref="top" title="소식톡톡 대상자별 소식"></ContentTitle>

    <div class="section_search">
      <div class="tray">
        <div class="row">
          <div class="cell">
            <template v-if="!rcpDetailData">
              <dt class="name">-</dt>
            </template>
            <template v-else>
              <dl class="target_info">
                <dt class="name">{{rcpDetailData.rcpName}}</dt>
                <dd
                  class="personal"
                >({{rcpDetailData.rcpGender}}/{{rcpDetailData.rcpAge}}세/{{rcpDetailData.rcpGroup}})</dd>
                <dd
                  class="member"
                >NUGU Device No: {{rcpDetailData.rcpNuguDeviceId}} | TID : {{rcpDetailData.rcpNuguTid}}</dd>
              </dl>
              <div class="sorting">
                <select v-model="newsType" :disabled="!permissions.recipient.range.modifiable">
                  <option value="self">작성한 소식</option>
                  <option value="all">전체 소식</option>
                </select>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <ul class="section_tab">
      <li v-for="item in tabArr" class="cell" :key="item.name">
        <router-link :to="item.to" class="item" active-class="selected">{{item.name}}</router-link>
      </li>
    </ul>

    <component
      :is="currentTab"
      :rcpId="$route.params.id"
      :registerType="newsType"
      @dataLoaded="onTableDataLoaded"
      ref="currentComp"
    />
  </LayoutDefault>
</template>

<script>
import newsMixin from "$views/News/_mixin";

import General from "./Recipient.general";
import RepeatTotal from "./Recipient.repeat.total";
import RepeatDaily from "./Recipient.repeat.daily";
import RepeatItemBy from "./Recipient.repeat.itemBy";

export default {
  mixins: [newsMixin],
  components: { General, RepeatTotal, RepeatDaily, RepeatItemBy },
  data() {
    const id = this.$route.params.id;
    const initialNewsType = _.get(
      this.$store.state,
      "permissions.recipient.range.type"
    );
    return {
      rcpDetailData: null,
      newsType: initialNewsType ? initialNewsType.toLowerCase() : "all",
      tabArr: [
        { name: "일반소식", to: "general" },
        { name: "반복/맞춤소식", to: "repeat" },
        { name: "반복소식 Daily 전송이력", to: "repeat_log_daily" },
        { name: "반복소식 건별 전송이력", to: "repeat_log_itemby" }
      ]
    };
  },
  computed: {
    currentTab() {
      switch (this.$route.params.tab) {
        case "repeat":
          return "RepeatTotal";
        case "repeat_log_daily":
          return "RepeatDaily";
        case "repeat_log_itemby":
          return "RepeatItemBy";
        case "general":
        default:
          return "General";
      }
    }
  },
  watch: {
    newsType() {
      this.$nextTick(() => {
        this.$refs.currentComp.loadData();
      });
    }
  },
  methods: {
    onTableDataLoaded(data) {
      if (!this.rcpDetailData) this.rcpDetailData = data;
    },
    onClickItem(comp) {
      this.currentTab = comp;
    }
  }
};
</script>
